import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Stack,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import TabPanel from "../../components/TabPanel";
import SalesOrderItems from "./sales-order/items";
import SalesOrderBilling from "./sales-order/billing";
import SalesOrderCustom from "./sales-order/custom";
import SalesOrderCommunication from "./sales-order/communication";
import SalesOrderSystemInformation from "./sales-order/system-information";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable";
import {
  relationshipContactTable,
  salesOrderApproverList,
  salesOrderAvaTaxTable,
  salesOrderPhilippinesTable,
  salesOrderRelatedRecordTable,
  salesOrderRelatedRecordTransformationTable,
} from "../../config/grid-column-defs";
import {
  getTransactionDocRelatedRecords,
  getTransactionSalesOrderDetail,
} from "../../api/transaction-type";
import SalesOrderRelatedRecords from "./sales-order/related-records";
import SalesOrderShipping from "./sales-order/shipping";
import SalesOrderChannel from "./sales-order/channel";
import SalesOrderEft from "./sales-order/eft";
import SalesOrderOpenAir from "./sales-order/open-air";
import SalesOrderTaxAndReporting from "./sales-order/tax&reporting";
import SalesOrderAvaTax from "./sales-order/ava-tax";
import SalesOrderOptionAndLogs from "./sales-order/options&logs";
import useSnackbar from "../../hooks/useSnackbar";
import { useSelector } from "react-redux";
import { slugMap } from "../../config/slug-config";
export default function TransactionTypeSalesOrder() {
  const snackbar = useSnackbar();
  const [loading, setLoading] = useState(false);
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);
  const [tabIndexRelationship, setTabIndexRelationship] = useState(0);
  const [tabIndexApproveList, setTabIndexApproveList] = useState(0);
  const [tabIndexAvaTax, setTabIndexAvaTax] = useState(0);
  const [tabIndexRelatedRecord, setTabIndexRelatedRecord] = useState(0);
  const [itemSum, setItemSum] = useState("");
  const [subTotal, setSubTotal] = useState("");
  const [gstHst, setGstHst] = useState("");
  const [discountItem, setDiscountItem] = useState("");
  const [pst, setPst] = useState("");
  const [tax, setTax] = useState("");
  const [rowData, setRowData] = useState([]);
  const [linkingdocumentno, setlinkingdocumentno] = useState("");
  const pageDetail = slugMap[params.slug];
  const [data, setData] = useState("");
  const [prepayInvoice, setPrepayInvoice] = useState("");
  /*----------------End Tabs-----------------*/

  useEffect(() => {
    if (user.token) {
      getTransactionDocDetailTableData();
    }
  }, []);
  async function getTransactionDocDetailTableData() {
    setLoading(true);
    try {
      const { data } = await getTransactionSalesOrderDetail(user.token, {
        tranid: params.docNo,
        type: pageDetail.path,
      });
      setRowData(data.data.details);
      setLoading(false);
      setData(data.data);
      setTax(data.data.tax);
      setGstHst(data.data.gst_hst);
      setPst(data.data.pst);
      setDiscountItem(data.data.discount_item);
      setlinkingdocumentno(data.data.linkingdocumentno);
      setSubTotal(data.data.subtotal);
      setPrepayInvoice(data.data.prepay_inv);
      return {
        rows: data.data.details,
        total: data.data.Detailstotal,
        error: false,
      };
    } catch (error) {
      setLoading(false);

      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      <Typography component="h4" fontWeight={500} className="pageTitle">
        Sales Order
      </Typography>
      {rowData.map((el, index) => (
        <>
          <Typography component="p" sx={{ mb: 2 }}>
            <span className="para-no">{rowData[0]?.tranid}</span> {el.customer}
          </Typography>
          {/*Primary Information*/}

          <Box className="viewBox" key={index}>
            <Box
              className="headerItems"
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              pb={2}
            >
              <Typography
                component="h5"
                fontWeight={500}
                className="pageHeading1"
              >
                Primary Information
              </Typography>
              <Link to={"/transaction-type/" + params.slug}>
                <Button size="small" className="backBtn">
                  Go Back
                </Button>
              </Link>
            </Box>
            <Box className="viewDetilsBox">
              <>
                <Grid container className="mb-2">
                  <Grid item xs={12} sm={6} md={8}>
                    <Grid container className="mb-2">
                      <Grid item xs={12} sm={6} md={6} className="m-b-10">
                        <p className="tFormlabel">ORDER #</p>
                        <p className="tFormName">{el.tranid}</p>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} className="m-b-10">
                        <p className="tFormlabel">CURRENCY</p>
                        <p className="tFormName">{el.currency}</p>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} className="m-b-10">
                        <p className="tFormlabel">EXCHANGE RATE</p>
                        <p className="tFormName">{el.exchangerate}</p>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} className="m-b-10">
                        <p className="tFormlabel">CRM CONTRACT #</p>
                        <p className="tFormName">{el.crm_contract_num}</p>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} className="m-b-10">
                        <p className="tFormlabel">CUSTOMER</p>
                        <p className="tFormName">{el.customer}</p>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} className="m-b-10">
                        <p className="tFormlabel">CUSTOMER PO#AFE#</p>
                        <p className="tFormName">{el.customer_po_afe_number}</p>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} className="m-b-10">
                        <p className="tFormlabel">CRM CUSTOMER ID</p>
                        {/* <p className="tFormName">Quorum Sales Order</p> */}
                        <p className="tFormName">{el.crm_customer_id}</p>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} className="m-b-10">
                        <p className="tFormlabel checkAndTextAlign">
                          {el.customer_self_remits_taxes == "F" ? (
                            <FormGroup>
                              <FormControlLabel
                                control={<Checkbox disabled />}
                                label="CUSTOMER SELF REMITS TAXES"
                              />
                            </FormGroup>
                          ) : (
                            <FormGroup>
                              <FormControlLabel
                                control={<Checkbox disabled checked />}
                                label="CUSTOMER SELF REMITS TAXES"
                              />
                            </FormGroup>
                          )}
                        </p>
                      </Grid>

                      <Grid item xs={12} sm={6} md={4} className="m-b-10">
                        <p className="tFormlabel checkAndTextAlign">
                          {el.po_afe_required == "F" ? (
                            <FormGroup>
                              <FormControlLabel
                                control={<Checkbox disabled />}
                                label="PO/AFE REQUIRED"
                              />
                            </FormGroup>
                          ) : (
                            <FormGroup>
                              <FormControlLabel
                                control={<Checkbox disabled checked />}
                                label="PO/AFE REQUIRED"
                              />
                            </FormGroup>
                          )}
                        </p>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} className="m-b-10">
                        <p className="tFormlabel checkAndTextAlign">
                          {prepayInvoice == "F" ? (
                            <FormGroup>
                              <FormControlLabel
                                control={<Checkbox disabled />}
                                label="PREPAY REQUIRED"
                              />
                            </FormGroup>
                          ) : (
                            <FormGroup>
                              <FormControlLabel
                                control={<Checkbox disabled checked />}
                                label="PREPAY REQUIRED"
                              />
                            </FormGroup>
                          )}
                        </p>
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* -----------Summary Box------------- */}
                  <Grid item xs={12} sm={6} md={4}>
                    <Box className="viewBox">
                      <Box
                        className="headerItemsSB"
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        pb={2}
                      >
                        <Typography
                          component="h5"
                          fontWeight={500}
                          className="pageHeading1"
                        >
                          Summary
                        </Typography>
                      </Box>
                      <Box className="viewDetilsBox1">
                        <Grid container>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormlabel">SUBTOTAL</p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormtotal">{subTotal}</p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormlabel">DISCOUNT ITEM</p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormtotal">{discountItem}</p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormlabel">GST/HST</p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormtotal">{gstHst}</p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormlabel">PST</p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormtotal">{pst}</p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormlabel">TAX</p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormtotal">{tax}</p>
                          </Grid>
                        </Grid>
                        <Divider />
                        <Grid container sx={{ mt: 1 }}>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormlabel">TOTAL</p>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className="m-b-10">
                            <p className="tFormtotal">{el.foreigntotal}</p>
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>
                  </Grid>
                  {/* -----------End Summary Box------------- */}
                  <Grid item xs={12} sm={6} md={6} className="m-b-10">
                    <p className="tFormlabel">OTHER CONTRACT INSTRUCTIONS</p>
                    {/* <p className="tFormName">Quorum Sales Order</p> */}
                    <p className="tFormName">
                      {el.customer_contract_instructions}
                    </p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} className="m-b-10">
                    <p className="tFormlabel">TERM START DATE</p>
                    {/* <p className="tFormName">2/28/2017</p> */}
                    <p className="tFormName">{el.trandate}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} className="m-b-10">
                    <p className="tFormlabel">TERMS</p>
                    {/* <p className="tFormName">2/28/2017</p> */}
                    <p className="tFormName">{el.terms}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} className="m-b-10">
                    <p className="tFormlabel">BILLING START DATE</p>
                    <p className="tFormName">{el.billing_start_date}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} className="m-b-10">
                    <p className="tFormlabel">SUBMITTING GUIDLINES</p>
                    <p className="tFormName">{el.submitting_guidelines}</p>
                    {/* <p className="tFormName">Lucid Energy Group</p> */}
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} className="m-b-10">
                    <p className="tFormlabel">REMITTANCE INFO</p>
                    <p className="tFormName">{el.remittance_info}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} className="m-b-10">
                    <p className="tFormlabel">MEMO TO CUSTOMER</p>
                    <p className="tFormName">{el.memo_to_customer}</p>
                    {/* <p className="tFormName">Lucid Energy Group</p> */}
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} className="m-b-10">
                    <p className="tFormlabel">INTERNAL MEMO</p>
                    <p className="tFormName">{el.internal_memo}</p>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel checkAndTextAlign">
                      {el.agent == "F" ? (
                        <FormGroup>
                          <FormControlLabel
                            control={<Checkbox disabled />}
                            label="AGENT? COMMISSION"
                          />
                        </FormGroup>
                      ) : (
                        <FormGroup>
                          <FormControlLabel
                            control={<Checkbox disabled checked />}
                            label="AGENT? COMMISSION"
                          />
                        </FormGroup>
                      )}
                    </p>
                  </Grid>
                </Grid>
              </>
            </Box>
          </Box>
        </>
      ))}
      {/*address Information*/}
      {rowData.map((el, index) => (
        <Box className="viewBox" key={index}>
          <Box
            className="headerItems"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            pb={2}
          >
            <Typography
              component="h5"
              fontWeight={500}
              className="pageHeading1"
            >
              Address Information
            </Typography>
          </Box>
          <Box className="viewDetilsBox">
            <>
              <Grid container className="mb-2">
                <Grid item xs={12} sm={5} md={4} className="m-b-10">
                  <p className="tFormlabel">BILL TO</p>
                  <p className="tFormName">{el.bill_to}</p>
                </Grid>
                <Grid item xs={12} sm={1} md={1} className="m-b-10">
                </Grid>
                <Grid item xs={12} sm={5} md={4} className="m-b-10">
                  <p className="tFormlabel">SHIP TO</p>
                  <p className="tFormName">{el.ship_to}</p>
                </Grid>
              </Grid>
            </>
          </Box>
        </Box>
      ))}
      {/*Sales Information*/}
      {rowData.map((el, index) => (
        <Box className="viewBox" key={index}>
          <Box
            className="headerItems"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            pb={2}
          >
            <Typography
              component="h5"
              fontWeight={500}
              className="pageHeading1"
            >
              Sales Information
            </Typography>
          </Box>
          <Box className="viewDetilsBox">
            <>
              <Grid container className="mb-2">
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">CRM QUOTE ID</p>
                  <p className="tFormName">{""}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">SALES REP</p>
                  <p className="tFormName">{el.sales_rep}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">SOURCE</p>
                  <p className="tFormName">{el.source}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">CRM OPPORTUNITY NUMBER</p>
                  <p className="tFormName">{""}</p>
                </Grid>

                {/* {el.linkingorderid === null ? (
                  <></>
                ) : (
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">CREATED FROM</p>
                    <p className="tFormName">
                      Sales Order <p className="link-color">#</p>
                      <Link
                        className="link-color"
                        target="_blank"
                        to={
                          "/transaction-type/sales-order/" +
                          `${el.linkingorderid}`
                        }
                      >
                        {linkingdocumentno}
                      </Link>
                    </p>
                  </Grid>
                )} */}
              </Grid>
            </>
          </Box>
        </Box>
      ))}

      {/*Classification*/}
      {rowData.map((el, index) => (
        <Box className="viewBox" key={index}>
          <Box
            className="headerItems"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            pb={2}
          >
            <Typography
              component="h5"
              fontWeight={500}
              className="pageHeading1"
            >
              Classification
            </Typography>
          </Box>
          <Box className="viewDetilsBox">
            <Grid container className="mb-2">
              <Grid item xs={12} sm={12} md={12} className="m-b-10">
                <p className="tFormlabel">SUBSIDIARY </p>
                <p className="tFormName">{el.subsidiary}</p>
                {/* <p className="tFormName">{el.subsidiary}</p> */}
              </Grid>

              {/* <Grid item xs={12} sm={6} md={8} className="m-b-10">
                <p className="tFormlabel">MANUAL RENEWAL</p>
                <p className="tFormName">{el.manual_renewal}</p>
              </Grid> */}
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">REVENUE TYPE</p>
                <p className="tFormName">{data?.revenue_type}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">DEPARTMENT</p>
                {/* <p className="tFormName">12</p> */}
                <p className="tFormName">{el.department}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">TAX REGION</p>
                {/* <p className="tFormName">
                811 Main Street Suite 2200 Houston TX 77002 United States
              </p> */}
                <p className="tFormName">{el.tax_region}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">SOLUTIONS</p>
                <p className="tFormName">{el.solution}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">OPERATIONS</p>
                <p className="tFormName">{el.operations}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">SALES MARKET REGION</p>
                <p className="tFormName">{el.sales_market_region}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">INVOICE MESSAGING</p>
                <p className="tFormName">{el.invoice_messaging}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                {/* <p className="tFormlabel">EXEMPTION CERTIFICATE RECEIVED?</p>
                  <p className="tFormName">
                    {el.exemption_certificate_received}
                  </p> */}
                <p className="tFormlabel checkAndTextAlign">
                  {el.exclude_from_electronic_bank_payments_processing ==
                    "F" ? (
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox disabled />}
                        label="EXCLUDE FROM ELECTRONIC BANK PAYMENTS PROCESSING"
                      />
                    </FormGroup>
                  ) : (
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox disabled checked />}
                        label="EXCLUDE FROM ELECTRONIC BANK PAYMENTS PROCESSING"
                      />
                    </FormGroup>
                  )}
                </p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">RBA EXCHANGE RATE</p>
                <p className="tFormName">{el.rba_exchange_rate}</p>
              </Grid>
              <Grid item xs={12} sm={8} md={8} className="m-b-10">
                {/* <p className="tFormlabel">EXEMPTION CERTIFICATE RECEIVED?</p>
                  <p className="tFormName">
                    {el.exemption_certificate_received}
                  </p> */}
                <p className="tFormlabel checkAndTextAlign">
                  {el.is_seller_importer_of_record == "F" ? (
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox disabled />}
                        label="IS SELLER IMPORTER OF RECORD CUSTOM DUTY AND IMPORT FESS"
                      />
                    </FormGroup>
                  ) : (
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox disabled checked />}
                        label="IS SELLER IMPORTER OF RECORD CUSTOM DUTY AND IMPORT FESS"
                      />
                    </FormGroup>
                  )}
                </p>
              </Grid>

              {/* <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">UPFRONT SERVICES INVOICE</p>
                <p className="tFormName">{el.upfront_services_invoice}</p>
              </Grid> */}

              <Grid item xs={12} sm={6} md={8} className="m-b-10">
                <Grid container>
                  <Grid item xs={12} sm={6} md={6} className="m-b-10">
                    <p className="tFormlabel">SHIP-TO ENTITY/USE CODE (2)</p>
                    <p className="tFormName">{el.ship_to_entity_use_code}</p>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} className="m-b-10">
                    <p className="tFormlabel">BILL-TO ENTITY/USE CODE</p>
                    <p className="tFormName">{el.bill_to_entity_use_code}</p>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>
      ))}
      <Box>
        <Box
          className="viewBox "
          sx={{
            maxWidth: { xs: "100%", sm: "100%", md: "100%" },
            bgcolor: "#fff",
          }}
        >
          <Tabs
            value={tabIndex}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg"
          >
            <Tab label={`Items ${itemSum}`} />

            <Tab label="Shipping" />
            <Tab label="Billing" />
            {/* <Tab label="Channel" /> */}
            <Tab label="Accounting" />
            <Tab label="Relationships" />

            <Tab label="Communication" />
            <Tab label="Related Records" />
            {/* <Tab label="Options & Log" /> */}
            <Tab label="System Information" />
            <Tab label="Custom" />
            {/* <Tab label="Approver List" /> */}
            <Tab label="EFT" />
            <Tab label="Tax Reporting" />
            {/* <Tab label="Philippines Invoicing" />
            <Tab label="Open Air" /> */}
            <Tab label="Ava Tax" />
          </Tabs>
          {/*------------Items------------*/}
          <TabPanel value={tabIndex} index={0}>
            <SalesOrderItems setItemSum={setItemSum} />
          </TabPanel>

          {/*------------Shipping------------*/}
          <TabPanel value={tabIndex} index={1}>
            <SalesOrderShipping
              // shippingCost={shippingCostKey}
              // shippingMethod={shippingMethodKey}
              tabIndexP={tabIndex}
            ></SalesOrderShipping>
          </TabPanel>
          {/*------------Billing------------*/}
          <TabPanel value={tabIndex} index={2}>
            {tabIndex === 2 && <SalesOrderBilling tabIndexP={tabIndex} />}
          </TabPanel>
          {/* <TabPanel value={tabIndex} index={2}>
            <Box className="viewDetilsBox">
              <Grid container className="mb-2">
                <Grid item xs={12} sm={6}>
                  <Grid container>
                    <Grid item xs={12} md={12} className="m-b-10">
                      <p className="titleHeading m-0">Shipping Information</p>
                    </Grid>
                    <Grid item xs={6} md={6} className="m-b-10">
                      <p className="tFormlabel">SHIP DATE</p>
                      <p className="tFormName">2/22/2017</p>
                    </Grid>
                    <Grid item xs={6} md={6} className="m-b-10">
                      <p className="tFormlabel">ACTUAL DATE</p>
                      <p className="tFormName">5/19/2023</p>
                    </Grid>
                    <Grid item xs={12} className="m-b-10">
                      <p className="tFormlabel">SHIPPING CARRIER</p>
                      <p className="tFormName">FedEx/USPS/More</p>
                    </Grid>
                    <Grid item xs={12} className="m-b-10">
                      <p className="tFormlabel">SHIPPING METHOD</p>
                      <p className="tFormName"></p>
                    </Grid>
                    <Grid item xs={12} className="m-b-10">
                      <p className="tFormlabel">
                        <FormGroup>
                          <FormControlLabel
                            control={<checkbox  disabled/>}
                            label="SHIP COMPLETE"
                          />
                        </FormGroup>
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Grid container className="mb-2">
                    <Grid item xs={12} md={12} className="m-b-10">
                      <p className="titleHeading m-0">Shipping Address</p>
                    </Grid>
                    <Grid item xs={12}>
                      <p className="tFormlabel">SHIP TO</p>
                      <p className="tFormName">
                        Agave Energy Holdings Inc. 326 Quay Ave. Artesia NM
                        88210 United States Map
                      </p>
                    </Grid>
                    <Grid item xs={12} className="m-b-10">
                      <p className="tFormlabel">SHIPPING CODE (2)</p>
                      <p className="tFormName"></p>
                    </Grid>
                    <Grid item xs={12} className="m-b-10">
                      <p className="tFormlabel">SHIP TO COUNTRY</p>
                      <p className="tFormName">US</p>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </TabPanel> */}
          {/*------------Channel------------*/}
          {/* <TabPanel value={tabIndex} index={3}>
            <SalesOrderChannel
              // shippingCost={shippingCostKey}
              // shippingMethod={shippingMethodKey}
              tabIndexP={tabIndex}
            ></SalesOrderChannel>
          </TabPanel> */}
          {/*------------Accounting------------*/}
          <TabPanel value={tabIndex} index={3}>
            <Box className="viewDetilsBox">
              <Grid container className="mb-2">
                <Grid item xs={12} sm={6} className="m-b-10">
                  <p className="tFormlabel">EXCHANGE RATE</p>
                  <p className="tFormName">1.00</p>
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
          {/*------------Relationships------------*/}
          <TabPanel value={tabIndex} index={4}>
            <Box className="viewDetilsBox">
              <Tabs
                value={tabIndexRelationship}
                onChange={(e, nv) => {
                  setTabIndexRelationship(nv);
                }}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
                className="tabs-sub-bkg"
              >
                <Tab label="Contacts" />
              </Tabs>
              <TabPanel value={tabIndexRelationship} index={0}>
                <Box>
                  <Grid container spacing={1} mt={1}>
                    <Grid item xs={12} sm={3} className="m-b-10">
                      <TextField
                        id="outlined-basic"
                        label="Contact"
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} className="m-b-10">
                      <FormControl size="small" fullWidth>
                        <InputLabel id="demo-select-small-label">
                          ROLE
                        </InputLabel>
                        <Select
                          labelId="demo-select-small-label"
                          id="demo-select-small"
                          value=""
                          label="Role"
                        //onChange={handleChange}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3} className="m-b-10">
                      <FormControl size="small" fullWidth>
                        <InputLabel id="demo-select-small-label">
                          VIEW
                        </InputLabel>
                        <Select
                          labelId="demo-select-small-label"
                          id="demo-select-small"
                          value=""
                          label="View"
                        //onChange={handleChange}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Box
                    sx={{
                      backgroundColor: "#bbd9e8",
                      p: 1,
                    }}
                  >
                    <Stack spacing={2} direction="row">
                      <Button className="blue-button">New Contact</Button>
                      <Button className="blue-button">Attach</Button>
                      <Button className="blue-button">Update Primary</Button>
                      <Button className="blue-button">Customize View</Button>
                    </Stack>
                  </Box>
                  <AgGridPaginatedTable
                    //getTableRows={getRelationshipContactTable}
                    columns={relationshipContactTable}
                    refreshCounter={0}
                  />
                </Box>
              </TabPanel>
            </Box>
          </TabPanel>

          {/*------------Communication------------*/}
          <TabPanel value={tabIndex} index={5}>
            {tabIndex === 5 && <SalesOrderCommunication tabIndexP={tabIndex} />}
          </TabPanel>
          {/*------------Related Record------------*/}
          <TabPanel value={tabIndex} index={6}>
            {tabIndex === 6 && (
              <SalesOrderRelatedRecords tabIndexP={tabIndex} />
            )}
            {/* <SalesOrderRelatedRecords
              tabIndexP={tabIndex}
            ></SalesOrderRelatedRecords> */}
          </TabPanel>
          {/*------------Options Log------------*/}
          {/* <TabPanel value={tabIndex} index={8}>
            <SalesOrderOptionAndLogs
              tabIndexP={tabIndex}
            ></SalesOrderOptionAndLogs>
          </TabPanel> */}
          {/*-------------System Information-----------*/}
          <TabPanel value={tabIndex} index={7}>
            <SalesOrderSystemInformation tabIndexP={tabIndex} />
          </TabPanel>
          {/*-------------CUSTOM-----------*/}
          <TabPanel value={tabIndex} index={8}>
            <SalesOrderCustom tabIndexP={tabIndex} />
          </TabPanel>
          {/*-------------Approver List-----------*/}
          {/* <TabPanel value={tabIndex} index={11}>
            <Box className="viewDetilsBox">
              <Grid container className="mb-2">
                <Grid item xs={12} sm={6} className="m-b-10">
                  <p className="tFormlabel">CREATED_BY</p>
                  <p className="tFormName">Brian Hammond</p>
                </Grid>
                <Grid item xs={12} sm={6} className="m-b-10">
                  <p className="tFormlabel">REVIEWER #2</p>
                  <p className="tFormName"></p>
                </Grid>
                <Grid item xs={12} sm={6} className="m-b-10">
                  <FormGroup>
                    <FormControlLabel
                      control={<checkbox  disabled/>}
                      label="SUPER APPROVER APPROVED"
                    />
                  </FormGroup>
                  <p className="tFormName"></p>
                </Grid>

                <Grid item xs={12} sm={6} className="m-b-10">
                  <p className="tFormlabel">REVIEWER #1</p>
                  <p className="tFormName"></p>
                </Grid>
                <Grid item xs={12} sm={6} className="m-b-10">
                  <p className="tFormlabel">TRANSACTION ORIGINAL AMOUNT</p>
                  <p className="tFormName"></p>
                </Grid>
              </Grid>
            </Box>
            <Box
              px={2}
              sx={{
                maxWidth: { xs: "100%", sm: "100%", md: "100%" },
                bgcolor: "#fff",
              }}
            >
              <Tabs
                value={tabIndexApproveList}
                // onChange={handleChange}
                onChange={(e, nv) => {
                  setTabIndexApproveList(nv);
                }}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
                className="tabs-sub-bkg"
              >
                <Tab label="NSTS | GAW-Approve List" />
              </Tabs>
              <TabPanel value={tabIndexApproveList} index={0}>
                <Box>
                  <Grid container spacing={2} py={2}>
                    <Grid item xs={12} sm={4} md={3}>
                      <FormControl fullWidth size="small">
                        <InputLabel id="demo-simple-select-label">
                          VIEW
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value=""
                          label="VIEW"
                        >
                          <MenuItem value="Default View">Default View</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Box>
                <Box
                  sx={{
                    backgroundColor: "#bbd9e8",
                    p: 1,
                  }}
                >
                  <Stack spacing={2} direction="row">
                    <Button className="blue-button">Customize View</Button>
                  </Stack>
                </Box>
              </TabPanel>
            </Box>
            <AgGridPaginatedTable
              // getTableRows={getTransactionCustomData}
              columns={salesOrderApproverList}
              perPage={5}
              refreshCounter={0}
            />
          </TabPanel> */}
          {/*------------EFT-----------*/}
          <TabPanel value={tabIndex} index={9}>
            <SalesOrderEft tabIndexP={tabIndex}></SalesOrderEft>
          </TabPanel>
          {/*-------------Tax Reporting-----------*/}
          <TabPanel value={tabIndex} index={10}>
            <SalesOrderTaxAndReporting
              tabIndexP={tabIndex}
            ></SalesOrderTaxAndReporting>
          </TabPanel>
          {/*----------Philippines Invoicing--------*/}
          {/* <TabPanel value={tabIndex} index={14}>
            <Box
              px={2}
              sx={{
                maxWidth: { xs: "100%", sm: "100%", md: "100%" },
                bgcolor: "#fff",
              }}
            >
              <Tabs
                value={tabIndexApproveList}
                // onChange={handleChange}
                onChange={(e, nv) => {
                  setTabIndexApproveList(nv);
                }}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
                className="tabs-sub-bkg"
              >
                <Tab label="SAL Printing History" />
              </Tabs>
              <TabPanel value={tabIndexApproveList} index={0}>
                <Box>
                  <Grid container spacing={2} py={2}>
                    <Grid item xs={12} sm={4} md={3}>
                      <FormControl fullWidth size="small">
                        <InputLabel id="demo-simple-select-label">
                          VIEW
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value=""
                          label="VIEW"
                        >
                          <MenuItem value="Default View">Default View</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <FormControl fullWidth size="small">
                        <InputLabel id="demo-simple-select-label">
                          SAL PRINTING HISTORY
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value=""
                          label="SAL PRINTING HISTORY"
                        >
                          <MenuItem value="Default View">None</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Box>
                <Box
                  sx={{
                    backgroundColor: "#bbd9e8",
                    p: 1,
                  }}
                >
                  <Stack spacing={2} direction="row">
                    <Button className="blue-button">Attach</Button>
                    <Button className="blue-button">Customize View</Button>
                  </Stack>
                </Box>
              </TabPanel>
            </Box>
            <AgGridPaginatedTable
              // getTableRows={getTransactionCustomData}
              columns={salesOrderPhilippinesTable}
              perPage={5}
              refreshCounter={0}
            />
          </TabPanel> */}
          {/*------------Open Air------------*/}
          {/* <TabPanel value={tabIndex} index={15}>
            <SalesOrderOpenAir tabIndexP={tabIndex}></SalesOrderOpenAir>
          </TabPanel> */}
          {/*------------AvaTax-----------*/}
          <TabPanel value={tabIndex} index={11}>
            <SalesOrderAvaTax tabIndexP={tabIndex}></SalesOrderAvaTax>
            {/* <Box
              sx={{
                maxWidth: { xs: 320, sm: 480, md: "100%" },
                bgcolor: "#fff",
              }}
            >
              <Tabs
                value={tabIndexAvaTax}
                // onChange={handleChange}
                onChange={(e, nv) => {
                  setTabIndexAvaTax(nv);
                }}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
                className="tabs-sub-bkg"
              >
                <Tab label="Logs" />
              </Tabs>
              <TabPanel value={tabIndexAvaTax} index={0}>
                <AgGridPaginatedTable
                  //getTableRows={getTransactionShippingAddressData}
                  columns={salesOrderAvaTaxTable}
                  perPage={5}
                  refreshCounter={0}
                />
              </TabPanel>
            </Box> */}
          </TabPanel>
        </Box>
      </Box>
    </>
  );
}
